import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWith401Handling } from './baseQueryWith401Handling';
import Region from '../models/Region';

export const settingsApi = createApi({
    reducerPath: 'settingsApi',
    baseQuery: baseQueryWith401Handling,
    endpoints: (builder) => ({
        getUserRegion: builder.query<Region, void>({
            query:() => ({
                url: "settings/user-region"
            })
        }),
        getRegions: builder.query<Region[], void>({
            query:() => ({
                url: "settings/regions"
            })
        })        
    }),
});

export const { 
    useGetUserRegionQuery,
    useGetRegionsQuery    
  } = settingsApi;
